// Matches the server's upload cap (POST /users/imports). Large enough for tens
// of thousands of rows (~18K ≈ 3.5MB) now that parsing + validation are
// server-side and async.
//
// NOTE: the client-side CSV parser that used to live here (header aliasing,
// phone/wallet normalization, per-row validation) is intentionally gone. The
// upload endpoint now parses and validates the file server-side (~230ms at 18K
// rows) and returns a READY job carrying the canonical counts, so there is ONE
// parser instead of two that could disagree — the class of bug where the client
// preview said "invalid" while the server happily imported the row.
// See api/src/user/service/import/parse-import-csv.ts.
export const MAX_FILE_SIZE = 20 * 1024 * 1024; // 20MB
